var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ban-form',{attrs:{"title":"编辑封禁","ban":_vm.ban},on:{"addban":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }